import verifiers from '../verifiers';
import constants from '../constants';
import { connectedStore } from '../../store';
import site from '../../site';

const {
  CUSTOM_HTML_TAG,
  RUNTIME_CONTAINER_CLASS,
  TEMPLATE_TAG,
  RUNTIME_RENDERING_ATTRIBUTE,
  fieldNames,
} = constants;

function injectCustomHtml(staticNode) {
  const store = connectedStore.get();
  const state = store.getState();

  const isRuntimeRenderStatus = verifiers.isRuntimeRender();

  if (!staticNode || !isRuntimeRenderStatus) return null;

  const embeds = staticNode.querySelectorAll(CUSTOM_HTML_TAG);

  embeds.forEach((embed) => {
    if (!embed.hasAttribute(RUNTIME_RENDERING_ATTRIBUTE)) return;
    const template = embed.querySelector(TEMPLATE_TAG);
    if (!template) return;

    const container = document.createElement('div');
    container.className = RUNTIME_CONTAINER_CLASS;
    container.innerHTML = template.innerHTML;
    container.style.pointerEvents = 'none';

    template.insertAdjacentElement('afterend', container);
  });

  const activePageId = site.selectors.getActivePageId(state);
  const siteSettings = site.selectors.getSettings(state);
  const pageSettings = site.selectors.getPage(state, activePageId);

  // Inject custom code from site and page settings
  Object.values(fieldNames).forEach((fieldName) => {
    const siteSnippets = siteSettings[fieldName] || [];
    const pageSnippets = pageSettings[fieldName] || [];

    const containers = [...siteSnippets, ...pageSnippets]
      .filter((snippet) => snippet.runtimeRendering)
      .map((code) => {
        const container = document.createElement('div');
        container.className = RUNTIME_CONTAINER_CLASS;
        container.style.pointerEvents = 'none';
        container.innerHTML = code.code;
        return container;
      });

    if (fieldName === fieldNames.HEAD_CODE) {
      const head = staticNode.querySelector('head');
      head.append(...containers);
    }

    if (fieldName === fieldNames.HEADER_CODE) {
      const body = staticNode.querySelector('body');
      body.prepend(...containers);
    }

    if (fieldName === fieldNames.FOOTER_CODE) {
      const body = staticNode.querySelector('body');
      body.append(...containers.toReversed());
    }
  });

  return staticNode;
}

export default injectCustomHtml;
